import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../../shared/global';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  defaultPage: string = '';
  constructor(private router: Router, private globals: Globals) {}

  ngOnInit(): void {
    this.defaultPage = this.globals.getUserInfo().defaultPage;
  }

  goBack() {
    const isUserLogged = localStorage.getItem('isUserLogged');
  
    if (isUserLogged === 'true') {
      const userInfo = this.globals.getUserInfo();
      this.router.navigate(['/' + userInfo.defaultPage]);
    } else {
      this.router.navigate(['/login']);
    }
  }
  
}
